module.exports = __webpack_public_path__ + "static/media/seller_suite-1.c6d4ed6a.jpg";